import { render, staticRenderFns } from "./ConfirmRgpd.vue?vue&type=template&id=18788641&"
import script from "./ConfirmRgpd.vue?vue&type=script&lang=ts&"
export * from "./ConfirmRgpd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports